import React, { useState } from 'react'
import styles from '../css/EditFootprintBanner.module.css'

export default function EditFootprintBanner({ added, dropped, typeChanges, onResetToBaseline, lock }) {
    const [confirming, setConfirming] = useState(false)

    const hasEdits = added > 0 || dropped > 0 || typeChanges > 0

    if (!hasEdits) return null

    return (
        <div className={styles.banner}>
            <span className={styles.summary}>
                Your edits this session:&nbsp;
                {added > 0 && <strong className={styles.added}>+{added} added</strong>}
                {added > 0 && (dropped > 0 || typeChanges > 0) && <span className={styles.dot}> · </span>}
                {dropped > 0 && <strong className={styles.dropped}>−{dropped} dropped</strong>}
                {dropped > 0 && typeChanges > 0 && <span className={styles.dot}> · </span>}
                {typeChanges > 0 && <strong>{typeChanges} type change{typeChanges !== 1 ? 's' : ''}</strong>}
            </span>
            <span className={styles.actions}>
                {confirming ? (
                    <>
                        <span className={styles.confirmText}>Undo session changes?</span>
                        <button className={styles.confirmBtn} onClick={() => { onResetToBaseline(); setConfirming(false) }}>Yes, undo</button>
                        <button className={styles.cancelBtn} onClick={() => setConfirming(false)}>Cancel</button>
                    </>
                ) : (
                    <button className={styles.resetBtn} onClick={() => setConfirming(true)} disabled={lock}>
                        [ Undo session changes ]
                    </button>
                )}
            </span>
        </div>
    )
}
